import React, { useEffect, useState } from "react";
import "./HomePage.scss";
import Hero from "./Hero";
import ChooseUs from "./ChooseUs";
import HowItWorks from "./HowItWorks";
import CarBrands from "./CarBrands";
import Testimonials from "./Testimonials";
import FollowUs from "./FollowUs";
import FAQ from "./FAQ";
import InstagramCarousel from "./InstagramCarousel";
import OurGallery from "./OurGallery";
import Footer from "./Footer";
import ServicePage from "./ServicePage";
import { Modal } from "@mui/material";
import ReactModal from "react-modal";
import CustomerLogin from "../../../components/auth/components/CustomerLogin";
import axios from "axios";
import VehicleModal from "../VehicleModal";
import PlayStore from "./PlayStore";
import WorkshopLocator from "../WorkshopLocator";
import CustomerInfoModal from "./CustomerInfoModal";
import { useHomePageQuery } from "../../../Services/inventory/Inventory";
import { CUST_ID } from "../../../constants";

interface IPROPS {
    setStoreVehicleInfo: any
    storeVehicleInfo: any
    storeGeoLocationData: any
    setStoreGeoLocationData: any
    setOpenVehicleModal: any
    openVehicleModal: any
    openModal: any
    setOpenModal: any
    isWorkshopSelectorClicked: any
    setIsWorkshopSelectorClicked: any
    setIsCartOpen: any
    isCartOpen: any
    vehicleData: any
    setVehicleData: any
    setIsOtpVerified: any
    isOtpVerified: any

}

const HomePage: React.FC<IPROPS> = ({ isOtpVerified, setIsOtpVerified, setVehicleData, vehicleData, setIsWorkshopSelectorClicked, setIsCartOpen, isCartOpen, isWorkshopSelectorClicked, openModal, setOpenModal, setOpenVehicleModal, openVehicleModal, setStoreVehicleInfo, storeVehicleInfo, setStoreGeoLocationData, storeGeoLocationData }) => {

    const [isCheckoutClicked, setIsCheckoutClicked] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const [cartItems, setCartItems] = useState<any[]>([]);
    const [isSubServiceModalOpen, setIsSubServiceModalOpen] = useState(false)
    //  const [homeApiData,setHomeApiData] = useState([])
    const [bannersData, setBannersData] = useState([])
    const [loading, setLoading] = useState(false)




    const token = localStorage.getItem("customer-token");

    const getUserId = localStorage.getItem(CUST_ID)

    const checkoutServices = () => {
        setIsCheckoutClicked(true);
    };

    const handleRemoveFromCart = (subServiceId: string) => {
        const updatedCart = cartItems.filter(
            (item) => item.sub_service?.id !== subServiceId
        );
        setCartItems(updatedCart);
        // updateSessionStorage(updatedCart);
    };

    const closeModal = () => {
        setIsSubServiceModalOpen(false)
        setIsCartOpen(false)
        setOpenModal('')


    }


    const fetchingTenant = window.location.hostname.split(".")[0];
    const apiPort = process.env.REACT_APP_API_PROTOCOL;


    const fetchBanners = async () => {
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/banners/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setBannersData(response?.data?.results);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
    };


    useEffect(() => {
        fetchBanners()

    }, [])


    const fetchVehicle = async () => {
        setLoading(true)
        try {
            const response = await axios.get(
                `${apiPort}://${fetchingTenant}.${process.env.REACT_APP_BASE_URL}/v1/gc/vehicles/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            setVehicleData(response?.data?.data);
        } catch (error) {
            console.error("Error fetching profile:", error);
        }
        finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if (token) {

            fetchVehicle();
        }
    }, [isOtpVerified]);






    const onClose = () => {
        setOpenVehicleModal(false)
        setOpenModal('')
    }

    const customModalStyles = {
        overlay: {
            zIndex: 1000,
        },
        content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "450px",
        },
    };




    useEffect(() => {
        if (!isCartOpen) {
            setCurrentStep(1)

        }

    }, [isCartOpen])

    //   useEffect(() => {
    //     const interval = setInterval(() => {
    //       localStorage.clear(); // or remove only specific items
    //       window.location.replace('/home');
    //     }, 60 * 60 * 1000); // 1 hour in milliseconds

    //     return () => clearInterval(interval); // cleanup on unmount
    //   }, []);


    // useEffect(() => {
    //     if (token) {
    //         localStorage.clear()
    //         window.location.replace('/home')

    //     }

    // }, [])


    return (
        <div className="home-page-cont">

            <>

                <div style={{ padding: "0 10px" }}>
                    <Hero bannersData={bannersData} setOpenModal={setOpenModal} setIsCartOpen={setIsCartOpen} setOpenVehicleModal={setOpenVehicleModal} vehicleData={vehicleData} fetchVehicle={fetchVehicle} />
                </div>

                <div>
                    <ChooseUs />
                </div>

                <div>
                    <HowItWorks setIsCartOpen={setIsCartOpen} />
                </div>

                <div>
                    <ServicePage setOpenModal={setOpenModal} vehicleData={vehicleData} setIsCartOpen={setIsCartOpen} setCurrentStep={setCurrentStep} setOpenVehicleModal={setOpenVehicleModal} />
                </div>

                {/* <div style={{ padding: "0 10px" }}>
                    <CarBrands />
                </div> */}
                <div>
                    <OurGallery />
                </div>

                <div style={{ padding: "0 10px" }}>
                    <Testimonials />
                </div>

                <div>
                    <FAQ />
                </div>

                <div>
                    <InstagramCarousel />
                </div>
                {/* <div>
                        <PlayStore />
                    </div> */}

                <div>
                    <FollowUs />
                </div>
            </>


            <div>
                <Footer />
            </div>



            <Modal
                open={isWorkshopSelectorClicked}
                onClose={() => {
                    setIsWorkshopSelectorClicked(false);
                }}
            >
                <WorkshopLocator
                    setStoreGeoLocationData={setStoreGeoLocationData}
                    storedGeoLoaction={storeGeoLocationData}
                    onClose={() => setIsWorkshopSelectorClicked(false)}
                />
            </Modal>


            {openVehicleModal && <VehicleModal fetchVehicle={fetchVehicle} vehicle={undefined} onClose={onClose} />}
            <ReactModal
                isOpen={openModal === "login"}
                onRequestClose={closeModal}
                style={customModalStyles}
                contentLabel="Change Status"
            >
                <CustomerLogin setOpenModal={setOpenModal} fetchVehicles={fetchVehicle} setIsOtpVerified={setIsOtpVerified} />
            </ReactModal>



            <CustomerInfoModal
                open={openModal === "contact"}
                onClose={() => setOpenModal('')}
            // onSubmit={handleCustomerSubmit}
            />


        </div>
    );
};

export default HomePage;